import { gzipSync, strToU8 } from 'fflate';
import type { ActivityPayload } from './contracts';

export type EncodedActivityPayload =
  | { compression: 'gzip'; body: ArrayBuffer }
  | { compression: 'identity'; body: string };

export const encodeActivityPayload = (payload: ActivityPayload): EncodedActivityPayload => {
  const json = JSON.stringify(payload);

  try {
    const compressed = gzipSync(strToU8(json), { mtime: 0 });
    return {
      compression: 'gzip',
      body: compressed.buffer.slice(
        compressed.byteOffset,
        compressed.byteOffset + compressed.byteLength
      ) as ArrayBuffer
    };
  } catch {
    return { compression: 'identity', body: json };
  }
};
